import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, InputBase } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './city-choose.scss';
import Color from '@tool/color';
import { CloseIcon20, DownFullIcon } from '@styled/icon';
import moCityStore, { toggleModal } from './city-store';
import moIndex, { toggleTip } from '../../store/index';
import moUser from '@store/user';

interface IProps {}
interface IState {}

const DInputBase = styled(InputBase)(() => ({
  height: '30px',
  padding: '0 10px',
  borderRadius: '4px',
  lineHeight: 1,
  border: `1px solid ${Color.blackColor(0.1)}`,
}));

const CityChoose = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { activeList } = moCityStore;
  const { isIndicatorExpired } = moUser;

  const onCity = () => {
    if (isIndicatorExpired) toggleTip(true);
    else toggleModal(true);
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="city-choose_10">
      <b>城市</b>
      <p onClick={onCity}
        className="line-11" aria-hidden="true">
        <span>已选{activeList.length}个城市</span>
        <DownFullIcon color={Color.da} />
      </p>
    </section>
  );
};

export default observer(CityChoose);
